<template>
  <div class="grid">
    <div v-for="(item, key) in items" :key="key" class="grid__item">
      <inline-svg class="grid__item-icon" :src="item.icon" />
      <div class="grid__item-content">
        <div class="grid__item-title" v-html="item.title" />
        <div class="grid__item-text" v-html="item.text" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Grid',
  props: {
    items: Array,
  },
}
</script>

<style scoped lang="scss">
@import "@/styles/breakpoints";
@import "@/styles/button-primary.scss";

.grid {
  display: flex;
  flex-wrap: wrap;
  gap: 36px 29px;

  .grid__item {
    width: 48%;
    display: flex;
    flex: 0 0 auto;
    gap: 16px;

    .grid__item-icon {
      width: 44px;
      height: 44px;
      flex: 1 0 auto;
      margin: -4px 0 0;
    }

    .grid__item-content {
      display: flex;
      flex-direction: column;
      gap: 6px;

      .grid__item-title {
        font-size: 20px;
        font-weight: 600;
        line-height: 40px;
      }

      .grid__item-text {
        font-size: 18px;
        line-height: 28px;
      }
    }
  }
}

@include media-breakpoint-down($size-tablet) {
  .grid {
    gap: 38px 20px;

    .grid__item {
      width: 100%;
      padding: 0 10px 0 0;
    }
  }
}

@include media-breakpoint-down($size-mobile) {
  .grid {
    gap: 28px 20px;

    .grid__item {
      gap: 7px;
      padding: 0;

      .grid__item-icon {
        width: 30px;
        height: 30px;
        margin: -3px 0 0;
      }

      .grid__item-content {
        gap: 9px;

        .grid__item-title {
          font-size: 16px;
          line-height: 24px;
        }

        .grid__item-text {
          font-size: 15px;
          line-height: 24px;
        }
      }
    }
  }
}
</style>
